import React, { memo } from "react";
import { css, cx } from "@emotion/css";
import { clearValueStyle } from "../../../styles";
const ClearValue = ({ isClearable, clearValueStyleFn, clearValue }) => {
    if (!isClearable)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: cx("react-auto-scroll-time-select__clear-value", css(clearValueStyleFn
            ? clearValueStyleFn(clearValueStyle)
            : clearValueStyle)), onClick: clearValue }, "\u00D7"));
};
export default memo(ClearValue);
